export default "__VITE_ASSET__DxpBsPao__"